export default "__VITE_ASSET__CTLDUvWR__"